import { render } from "./PlanillaCrearForm.vue?vue&type=template&id=618ba64a&scoped=true"
import script from "./PlanillaCrearForm.vue?vue&type=script&lang=js"
export * from "./PlanillaCrearForm.vue?vue&type=script&lang=js"

import "@/assets/css/tabs.css?vue&type=style&index=0&id=618ba64a&scoped=true&lang=css"
import "./PlanillaCrearForm.vue?vue&type=style&index=1&id=618ba64a&scoped=true&lang=css"
import "./PlanillaCrearForm.vue?vue&type=style&index=2&id=618ba64a&scoped=true&lang=css"
import "./PlanillaCrearForm.vue?vue&type=style&index=3&id=618ba64a&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\allikamay\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-618ba64a"]])

export default __exports__